import styled from 'styled-components';
import {
	H1, RspImageBg, Column
} from '../../components/base';
import media from '../../components/base/media';

export const Wrapper = styled.div`
	padding: 5rem 0;
	padding-top: calc(${props => props.theme.header.headerHeightMobile} + 5rem);

	${media.tablet`
		padding: 10rem 0;
	`}

	${media.desktopSmall`
		padding: 24rem 0 12rem 0;
	`}
`;

export const Content = styled.div`
	${media.tablet`
		max-width: 80%;
	`}

	${media.desktopLarge`
		max-width: 70rem;
	`}
`;

export const Title = styled(H1)`
	margin-bottom: 3rem;

	${media.desktopSmall`
		margin-bottom: 5rem;
	`}
`;

export const Text = styled.div`
	margin: 2rem 0;

	${media.desktopSmall`
		margin-bottom: 5rem;
	`}
`;

export const Image = styled(RspImageBg)`
	padding-top: 100%;
	background-size: cover;
	background-position: 50% 50%;

	${media.tablet`
		padding-top: 200%;
	`};

	${media.desktopSmall`
		padding-top: 140%;
	`}
`;

export const SettingsContent = styled.div`
	margin-top: 5rem;
`;

export const Addresses = styled.div`
	margin-bottom: 3rem;
`;

export const Address = styled.div`
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};

	> *:not(:first-child) {
		margin-right: 5px;
	}
`;

export const Info = styled.div`

`;

export const InfoLine = styled.div`
	display: flex;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};

	> * {
		margin-right: 5px;
	}
`;

export const ContentColumn = styled(Column)`
	order: 2;

	${media.tablet`
		order: 1;
	`}
`;

export const ImageColumn = styled(Column)`
	order: 1;

	${media.tablet`
		order: 2;
	`}
`;
